import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w151q2y6",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i1yidkpv",
  propsAsIs: false
});
const ContentContainer = /*#__PURE__*/styled('div')({
  name: "ContentContainer",
  class: "c6k8r4e",
  propsAsIs: false
});
const ReviewSection = /*#__PURE__*/styled('div')({
  name: "ReviewSection",
  class: "rjma5bd",
  propsAsIs: false
});
const ReviewDetailSection = /*#__PURE__*/styled('div')({
  name: "ReviewDetailSection",
  class: "r1c060mx",
  propsAsIs: false
});
const PriceSection = /*#__PURE__*/styled('div')({
  name: "PriceSection",
  class: "p13i5qw3",
  propsAsIs: false
});
const PriceDetails = /*#__PURE__*/styled('div')({
  name: "PriceDetails",
  class: "pjukquq",
  propsAsIs: false
});
export const PriceDetailsSkeleton = () => <PriceDetails>
    <SkeletonLoader width={24} height={16} marginTop={2} />
    <SkeletonLoader width={42} height={32} marginTop={2} />
  </PriceDetails>;
export const SuggestionHotelCardSkeleton = () => {
  return <Wrapper>
      <ImageWrapper>
        <SkeletonLoader width={350} height={200} />
      </ImageWrapper>
      <ContentContainer>
        <div>
          <SkeletonLoader width={67} height={12} marginTop={4} />
          <SkeletonLoader width={100} height={24} marginTop={2} />
        </div>
        <ReviewSection>
          <SkeletonLoader width={32} height={32} />
          <ReviewDetailSection>
            <SkeletonLoader width={55} height={16} />
            <SkeletonLoader width={79} height={14} />
          </ReviewDetailSection>
        </ReviewSection>

        <PriceSection>
          <SkeletonLoader width={68} height={14} />
          <PriceDetailsSkeleton />
        </PriceSection>
      </ContentContainer>
    </Wrapper>;
};

require("./SuggestionHotelCardSkeleton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestionHotelCardSkeleton.tsx");